import { Text, Spinner, Skeleton, Box } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';

interface AiLoadingStateProps {
  loadingText?: string;
}

function AiLoadingState({
  loadingText,
}: Readonly<AiLoadingStateProps>): JSX.Element {
  const { t } = useTranslation(Domain.CATALOG);
  const defaultLoadingText =
    loadingText || t('products.detail.seo.aiCategorySuggestions.loadingText');
  return (
    <Box display="flex" flexDirection="column" gap="4">
      <Skeleton width="100%" height="20px" borderRadius="7px" />

      <Box
        width="100%"
        padding="3"
        backgroundColor="neutral-surface"
        borderRadius="2"
      >
        <Box
          display="flex"
          gap="2"
          alignItems="center"
          justifyContent="flex-start"
        >
          <Spinner size="small" color="neutral-textLow" />
          <Text fontSize="caption" color="neutral-textLow">
            {defaultLoadingText}
          </Text>
        </Box>
      </Box>
    </Box>
  );
}

export default AiLoadingState;
